import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-shrink",
  "use": "icon-icon-shrink-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-icon-shrink\"><g><path d=\"M15 7h-6v-6h2v4h4zM7 15h-2v-4h-4v-2h6zM10 7c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l5-5c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-5 5c-.195.195-.451.293-.707.293zM1 16c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l5-5c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-5 5c-.195.195-.451.293-.707.293z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol